import linkPrefix from "./../linkPrefix.json"

export default class ServerPath {
    public static get(url: string): string {
        return linkPrefix.prefix + url
    }
}